export default "__VITE_ASSET__DFHOl2kg__"